import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPersonAddSvg } from "./IconPersonAddSvg.mjs";
const IconPersonAdd = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPersonAddSvg, ...svgProps }) });
export {
  IconPersonAdd
};
